import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsCoinsActive = () => {
  return useIsFeatureActive('ff_coins_rollout').isActive;
};
